define('home/views/NotificationCardLoginView',[
    'backbone-marionette',
    'home/templates/notificationCardLogin',
    'home/utils/navigationUtils',
], function (
    Marionette,
    notificationCardLoginTemplate,
    NavigationUtils
) {
    'use strict';

    var NotificationCardLoginView = Marionette.ItemView.extend({
        className: 'card-notif-invite card-notif-note',

        events: {
            'click [data-action=login]': 'navigateToLogin',
        },

        template: notificationCardLoginTemplate,

        navigateToLogin: function (evt) {
            if (evt)
                evt.preventDefault();

            NavigationUtils.navigateToLogin();
        },
    });

    return NotificationCardLoginView;
});

